var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"block text-sm font-medium text-gray-700"},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.required ? "*" : "")+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }